import React from 'react';
import { CogIcon as HeroCogIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type CogIconProps = Omit<IconProps, 'children'>;

export const CogIcon: React.FC<CogIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroCogIcon />
        </Icon>
    );
};
